import React from "react";
import { LOCALE_STRINGS } from "constants/locales";
import { ReactComponent as TruckIcon } from "assets/icons/truckIcon.svg";
import { ReactComponent as CheckSquareIcon } from "assets/icons/checkSquareIcon.svg";

export const FinancingSection = ({ language = "EN" }) => {
  const langKey = language?.toUpperCase?.() || "EN";
  const strings = LOCALE_STRINGS?.[langKey] || LOCALE_STRINGS?.[language] || {};

  return (
    <section className="financing-section-wrapper">
      <div className="financing-content-block">
        
        <div className="financing-header-container">
          <h2 className="financing-heading">
            {strings.financing_title || "Financing on both sides of the shipment"}
          </h2>
          <p className="financing-supporting-text">
            {strings.financing_subtitle ||
              "Whichever side of the trade you're on, capital shouldn't wait on the goods to move first"}
          </p>
        </div>

        <div className="financing-cards-container">
          
          <div className="finance-card">
            <div className="finance-icon-container">
              <TruckIcon />
            </div>
            <div className="finance-card-content">
              <h3 className="finance-card__title">
                {strings.financing_card1_title || "Pre-Shipment Financing"}
              </h3>
              <p className="finance-card__description">
                {strings.financing_card1_desc ||
                  "A revolving trade credit line for importers and exporters, so purchase and production costs get funded before goods ever leave the factory floor."}
              </p>
            </div>
          </div>

          <div className="finance-card">
            <div className="finance-icon-container">
              <CheckSquareIcon />
            </div>
            <div className="finance-card-content">
              <h3 className="finance-card__title">
                {strings.financing_card2_title || "Post-Shipment Financing"}
              </h3>
              <p className="finance-card__description">
                {strings.financing_card2_desc ||
                  "Invoice factoring and receivables financing that give exporters immediate liquidity against outstanding invoices — no waiting on a buyer's payment terms."}
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};